export enum VerticalPosition {
  Above = 'above',
  Below = 'below',
}

export enum HorizontalPosition {
  After = 'after',
  Before = 'before',
}
